export { default as StrategyMap } from './StrategyMap';
